<template>

  <f7-block-title>{{ $t('DeviceDeActivations') }}</f7-block-title>
  <f7-list v-if="isActivationDataLoaded">
    <f7-list-item
        link="/dashboard/activated-devices/?period=day&type=deactivation"
        :title="$t('Today')"
        :after="numeralFormat(today)"
    >
    </f7-list-item>
    <f7-list-item
        link="/dashboard/activated-devices/?period=week&type=deactivation"
        :title="$t('ThisWeek')"
        :after="numeralFormat(thisWeek)"
    >
    </f7-list-item>
    <f7-list-item
        link="/dashboard/activated-devices/?period=month&type=deactivation"
        :title="$t('ThisMonth')"
        :after="numeralFormat(thisMonth)"
    >
    </f7-list-item>
  </f7-list>
  <f7-list v-else>
    <f7-list-item
        v-for="item in 3"
        title="title"
        after="number"
        link
        class="skeleton-text skeleton-effect-wave"
        :key="`skeleton-device-activations-${item}`"
    >
    </f7-list-item>
  </f7-list>

</template>

<script>
import moment from "moment-mini"
import {mapGetters} from "vuex";
import {QTAPI} from "../../../services/qt-api";
import {isObjEmpty} from "../../../js/helpers";

export default {
  name: "dashboard-deactivations",

  data(){

    return {
      today: 0,
      thisWeek: 0,
      thisMonth: 0,
      isActivationDataLoaded: false
    }
  },

  computed: {
    ...mapGetters(['MajorToken', 'MinorToken', 'UserInfoPreEdit']),
  },

  /*watch: {
    UserInfoPreEdit(data){
      if(!isObjEmpty(data)){
        this.getData()
      }
    }
  },*/

  mounted() {
    //if(!isObjEmpty(this.UserInfoPreEdit)){
      this.getData()
    //}
  },

  methods: {
    async getData(){
      let solutionsStr = 'DeActivate'

      let [responseToday, responseThisWeek, responseThisMonth] = await Promise.allSettled([
        QTAPI.GetActivationHistory({
          MajorToken: this.MajorToken,
          MinorToken: this.MinorToken,

          From: moment.utc().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          To: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
          SolutionCodes: solutionsStr || ''
        }),
        QTAPI.GetActivationHistory({
          MajorToken: this.MajorToken,
          MinorToken: this.MinorToken,

          From: moment.utc().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
          To: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
          SolutionCodes: solutionsStr || ''
        }),
        QTAPI.GetActivationHistory({
          MajorToken: this.MajorToken,
          MinorToken: this.MinorToken,

          From: moment.utc().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          To: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
          SolutionCodes: solutionsStr || ''
        })
      ]);
      if(responseToday.status === 'fulfilled') this.today = Array.isArray(responseToday.value) ? responseToday.value.length : 0
      if(responseThisWeek.status === 'fulfilled') this.thisWeek = Array.isArray(responseThisWeek.value) ? responseThisWeek.value.length : 0
      if(responseThisMonth.status === 'fulfilled') this.thisMonth = Array.isArray(responseThisMonth.value) ? responseThisMonth.value.length : 0

      this.isActivationDataLoaded = true


    }
  }
}
</script>
